import _ from 'lodash';
import { DiscountEligibility, TravelTypes } from '../constants';

const getFiltersFromTrip = (trip) => {
  if (!trip) {
    return {
      staterooms: [],
      city: null,
    };
  }
  const roomSearchInput = trip.roomSearchInput ? [...trip.roomSearchInput] : [];

  let cruiseItinerary =
    trip.tripSegments &&
    trip.tripSegments.length > 0 &&
    (_.find(trip.tripSegments || [], (ts) => ts.mode === TravelTypes.cruise) || {}).itinerary;
  if (!cruiseItinerary) {
    cruiseItinerary = trip.cruiseItinerary;
  }

  _.each(trip.roomSearchInput, (stateroom, index) => {
    const discounts = [];
    if (stateroom && stateroom.pastPassengerNumber) {
      discounts.push(DiscountEligibility.PAST_PASSENGER);
    }
    if (stateroom && stateroom.passengerOccupation) {
      discounts.push(DiscountEligibility.OCCUPATION);
    }
    const pastPassengerNumbers = [];
    if (
      cruiseItinerary &&
      cruiseItinerary.itineraryDetail &&
      cruiseItinerary.itineraryDetail.cruiseLine &&
      stateroom &&
      stateroom.pastPassengerNumber
    ) {
      pastPassengerNumbers.push({
        cruiseLineId: cruiseItinerary.itineraryDetail.cruiseLine.cruiseLineId,
        value: stateroom.pastPassengerNumber,
      });
    }
    roomSearchInput[index] = {
      ...roomSearchInput[index],
      discounts,
      pastPassengerNumbers,
    };
  });
  return {
    staterooms: roomSearchInput,
    city: trip.passengerCity
      ? {
          value: trip.passengerCity.code || '',
          label: trip.passengerCity.name || '',
        }
      : null,
  };
};

export default getFiltersFromTrip;
